import React, {useEffect, useState} from 'react';
import useHTTP from "@/hooks/useHTTP.mjs";
import runAsync from "@/script/runAsync.mjs";
import {Col, Form, Input, Spin, Typography} from "antd";
import Modal from "@/components/Modal/Modal";
import DatePicker from "../../../../components/Form/DatePicker";
import moment from "moment/moment";

const {Text} = Typography

export default function BrfSchedule({record, onOk, ...props}) {
    const http = useHTTP();
    const [form] = Form.useForm()
    const [loading, setLoading] = useState(false);

    const handleOk = async () => {
        form.validateFields().then(async values => {
            try {
                setLoading(true)
                await runAsync(
                    async () => {
                        return await http.post(`/brf/schedule`, {...values}, {headers: {prjId: record.prjId, sVer: record.sVer}});
                    }, {
                        error: {content: (err) => `排期失败: ${err.message}`},
                        loading: {show: true},
                        success: {show: true},
                    });
                onOk(true)
            } catch (err) {
                console.log(err);
            } finally {
                setLoading(false)
            }
        })
    }

    useEffect(() => {

        const formFieldProductionStartDate = record.productionStartDate ? moment(record.productionStartDate) : null
        const formFieldProductionEndDate = record.productionEndDate ? moment(record.productionEndDate) : null
        form.setFieldsValue({
            ...record,
            productionStartDate: formFieldProductionStartDate,
            productionEndDate: formFieldProductionEndDate,
        })
        // form.setFieldsValue(record)
    }, []);

    return (
        <Modal
            title="提交排期"
            width="600px"
            {...props}
            onOk={handleOk}
        >
            <Spin spinning={loading}>
                <Form form={form} layout="vertical">
                    <Form.Item name='pkid' hidden><Input/></Form.Item>
                    <Form.Item
                        name='productionWindow'
                        label='投产期编号'
                        rules={[
                            {
                                required: true,
                                message: '请输入投产窗口',
                            },
                        ]}
                    >
                        <Input allowClear/>
                    </Form.Item>
                    <Form.Item name="productionStartDate" label="投产起始日期">
                        <DatePicker/>
                    </Form.Item>
                    <Form.Item name="productionEndDate" label="投产截止日期">
                        <DatePicker/>
                    </Form.Item>
                    <Form.Item name='actionDescription' label='备注'>
                        <Input.TextArea rows={4} allowClear/>
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    )
};
